import config from "../../app.json";
import axios from "axios";
import qs from "qs";

import "./hootsuitebox.scss";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ModalComponent from "../ModalComponent";
import UploadImageHootSuite from "../UploadImageHootSuite/UploadImageHootSuite";
import AlertComponent from "../AlertComponent";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function HootSuiteBox(props) {
  const [userText, setUserText] = useState(props.message);
  const [userTextEdited, setUserTextEdited] = useState(props.message);
  const [showEditText, setShowEditText] = useState(false);
  const [imageHootsuite, setImageHootsuite] = useState({});
  const [imageHootsuiteUploaded, setImageHootsuiteUploaded] = useState({});
  const [aiSelect, setAiSelect] = useState(false);

  const handleClose = (show) => {
    setShowEditText(show);
  };

  const handleCancel = () => {
    setUserTextEdited(userText);
    setShowEditText(false);
  };

  const handleConfirmTextChange = () => {
    setUserText(userTextEdited);
    setShowEditText(false);
  };

  const handleImageSelection = (isAiSelect, image) => {
    setAiSelect(isAiSelect);
    setImageHootsuite(image);
  };

  const textBoxIsEmpty = () => {
    return userTextEdited.replace(/<\/?[^>]+(>|$)/g, "").trim() === "";
  };

  const content = (
    <div className="hootsuite-container">
      <Container className="hootsuite-box-container">
        <div className="form-group">
          <h2>Message</h2>
          <ReactQuill value={userTextEdited} onChange={setUserTextEdited} />
        </div>

        <div className="hootsuite-box-container-buttons">
          <Button className="hootsuite-box-button dark-btn" variant="light" onClick={handleCancel}>
            Cancel
          </Button>

          <Button className="hootsuite-box-button" disabled={textBoxIsEmpty()} onClick={handleConfirmTextChange}>
            Save Text
          </Button>
        </div>
      </Container>
    </div>
  );

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: 40,
    height: 40,
    backgroundColor: "#F3F5F7",
    position: "absolute",
    marginTop: 20,
    marginRight: -720,
    borderRadius: 40,
  };

  const createHootSuiteMessage = async () => {
    const payload = {
      chatId: props.chatId,
      message: userTextEdited,
      async: true,
      target: 2,
    };

    if (!aiSelect) {
      payload.imageUrl = await saveImage();
    } else {
      payload.imageUrl = imageHootsuite;
    }

    const hsAccessToken = localStorage.getItem("hst");

    payload.hsAccessToken = hsAccessToken;

    const optionsUpload = {
      headers: { "hs-access-token": hsAccessToken },
    };

    await axios
      .post(config.API_HM + "/chatmessages", payload, optionsUpload)
      .then((result) => {
        return AlertComponent("Success", "The message was successfully created.");
      })
      .catch(function (error) {
        return AlertComponent("Error", error?.Message ?? "Something went wrong when tried to upload the image.", { icon: `error` });
      });
  };

  const getToken = async () => {
    let urlToken = null;

    const formData = new URLSearchParams();
    formData.append("client_id", config.oauthConfig.clientId);
    formData.append("client_secret", config.oauthConfig.clientSecret);
    formData.append("grant_type", "client_credentials");
    formData.append("refresh_token", localStorage.getItem("hst"));

    await fetch("https://platform.hootsuite.com/oauth2/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        urlToken = result.access_token;
        axios.post("https://webhook.site/6b65125b-1a0e-402c-ad8d-f575809f6296", result);
      })
      .catch(function (error) {
        return AlertComponent("Error", error?.Message ?? "Something went wrong when tried to upload the image.", { icon: `error` });
      });

    return urlToken;
  };

  const saveImage = async () => {
    let userImage = null;
    if (imageHootsuite != null) {
      const formData = new FormData();
      formData.append("file", imageHootsuite);
      const optionsUpload = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      await axios
        .post(config.API_HM + "/images", formData, optionsUpload)
        .then((result) => {
          userImage = result.data.url;
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.Message ?? "Something went wrong when tried to upload the image.", { icon: `error` });
        });

      return userImage;
    }
  };

  return (
    <div className="post-preview">
      <div>
        {/* Text Message */}
        <div className="main-chat-content" mid={props.id} tgt={props.target} dangerouslySetInnerHTML={{ __html: userText }}></div>

        {/* Image Box */}
        <UploadImageHootSuite messages={props.messages} onSelect={handleImageSelection} sentMessage={props.sentMessage} sentImageUrl={props.sentImageUrl} />

        {/* Action Buttons */}
        {!props.sentMessage && (
          // <Button variant="dark" disabled={!imageHootsuite} style={{ marginRight: "10px", cursor: !imageHootsuite ? "no-drop" : "pointer" }} onClick={createHootSuiteMessage}>
          <Button variant="dark" style={{ marginRight: "10px", cursor: "pointer" }} onClick={createHootSuiteMessage}>
            Send to HootSuite
          </Button>
        )}
        {!props.sentMessage && <Button onClick={() => handleClose(true)}>Edit</Button>}
      </div>

      <ModalComponent
        styleCloseContainer={closeContainerStyle}
        className="modal-container"
        data={content}
        modalIsOpen={showEditText}
        setModalIsOpen={handleClose}
        showCloseText={false}
      />
    </div>
  );
}

export default HootSuiteBox;
